<template>
  <div id="main_container">
    <div id="plaid_ad_container">
      <div id="plaid-continue-section">
        <div id="image_title_container">
          <img
            src="../../../assets/img/plaid_logo.svg"
            id="logo"
            width="136"
            height="52"
            alt="logo plaid"
          />
          <div>
            <h2 id="connect_title">
              <span id="connect_word">Connect</span> your business checking account with Plaid to take advantage of:
            </h2>
          </div>
        </div>
        <div style="display: flex;" id="advantages-icon-main-container">
          <div class="adv-icon-item">
            <div class="adv-icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="29" height="32" viewBox="0 0 29 32" fill="none">
                <path d="M12.74 8.34997C19.48 7.43997 24.12 14.52 20.19 20.1C15.68 26.52 5.45001 22.37 6.70001 14.38C7.13001 11.6 9.93001 8.72997 12.74 8.34997ZM14.05 10.03C6.51001 10.11 6.72001 21.57 14.16 21.48C21.6 21.39 21.52 9.94996 14.05 10.03Z" fill="#666666"/>
                <path d="M13.44 3.50995C11.06 3.52995 8.68995 4.48995 6.76995 5.84995C1.26995 9.76995 0.199952 17.7199 4.17995 23.1099C4.78995 23.9399 6.71995 25.2499 5.92995 26.1799C5.13995 27.1099 3.99995 25.6699 3.42995 25.0099C-4.30005 16.07 1.86995 1.95995 13.61 1.68995C12.77 0.749948 13.52 -0.480052 14.69 0.199948C14.8 0.259948 16.36 1.82995 16.43 1.93995C16.6 2.22995 16.65 2.42995 16.59 2.76995C16.53 3.10995 14.69 4.94995 14.35 5.00995C13.31 5.18995 13.03 4.35995 13.45 3.51995L13.44 3.50995Z" fill="#666666"/>
                <path d="M14.5999 29.81C15.4399 30.76 14.6799 31.98 13.5199 31.3C13.3599 31.21 11.6999 29.48 11.6599 29.36C11.5699 29.07 11.5899 28.76 11.7099 28.49C11.7599 28.37 13.3899 26.73 13.5199 26.66C14.5699 26.05 15.3299 26.96 14.7699 27.99C19.3599 27.89 23.8399 24.72 25.5199 20.47C27.3199 15.93 26.4199 11.29 23.3599 7.56998C22.8099 6.89998 21.4899 6.23998 22.2799 5.31998C23.0699 4.39998 24.2799 5.90998 24.8499 6.57998C32.5199 15.53 26.2699 29.54 14.5999 29.82V29.81Z" fill="#666666"/>
                <path d="M12.0702 13.3C13.3202 12.92 13.7802 14.66 14.5502 14.89C15.1702 15.07 17.3302 14.57 16.5002 16.25C16.2702 16.72 14.0402 16.69 13.6102 16.49C13.4902 16.43 11.7602 14.71 11.7102 14.59C11.5102 14.17 11.5502 13.46 12.0702 13.3Z" fill="#666666"/>
              </svg>
            </div>
            <div  class="adv-text-container">
              2x Faster<br/>
              Funding
            </div>
          </div>
          <div class="adv-icon-item">
            <div class="adv-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="32" viewBox="0 0 27 32" fill="none">
                <path d="M8.23997 19.25C8.62997 19.25 8.94997 19.57 8.94997 19.96C8.94997 20.26 9.18997 20.5 9.48997 20.5C9.78997 20.5 10.03 20.26 10.03 19.96C10.03 19.17 9.51997 18.49 8.77997 18.26V17.88C8.77997 17.58 8.53997 17.34 8.23997 17.34C7.93997 17.34 7.69997 17.58 7.69997 17.88V18.26C6.87997 18.52 6.34997 19.33 6.45997 20.19C6.56997 21.09 7.32997 21.76 8.22997 21.76C8.61997 21.76 8.94997 22.07 8.94997 22.47C8.94997 22.86 8.62997 23.18 8.23997 23.18C7.84997 23.18 7.52997 22.86 7.52997 22.47C7.52997 22.17 7.28997 21.93 6.98997 21.93C6.68997 21.93 6.44997 22.17 6.44997 22.47C6.44997 23.25 6.95997 23.94 7.69997 24.17V24.55C7.69997 24.85 7.93997 25.09 8.23997 25.09C8.53997 25.09 8.77997 24.85 8.77997 24.55V24.17C9.59997 23.91 10.13 23.1 10.02 22.24C9.89997 21.35 9.13997 20.67 8.23997 20.67C7.84997 20.67 7.52997 20.35 7.52997 19.96C7.52997 19.57 7.84997 19.25 8.23997 19.25Z" fill="#666666"/>
                <path d="M26.35 10.9501C26.77 10.5301 27 9.9801 27 9.3801C27 8.8001 26.76 8.2301 26.35 7.8201L19.24 0.730101C19.18 0.660101 19.12 0.600101 19.07 0.570101C18.32 -0.179899 17.08 -0.189899 16.34 0.540101C16.26 0.600101 16.18 0.660101 16.13 0.730101L6.1 10.7701H2.21C0.99 10.7701 0 11.7601 0 12.9801V29.4401C0 30.6601 0.99 31.6501 2.21 31.6501H24.77C25.95 31.6501 26.98 30.6901 26.98 30.1101V13.6601C26.98 12.4301 26.7 11.6701 26.08 11.2101L26.33 10.9601L26.35 10.9501ZM15.82 9.5101C16.57 9.5101 17.2 10.0401 17.33 10.7701H14.31C14.44 10.0401 15.06 9.5101 15.82 9.5101ZM23.61 9.7801L22.62 10.7701H18.42C18.28 9.4501 17.16 8.4201 15.82 8.4201C14.48 8.4201 13.35 9.4401 13.21 10.7701H9.97L17.29 3.4501C17.55 3.5001 17.81 3.5001 18.06 3.4501L23.6 9.0001C23.57 9.1401 23.55 9.2701 23.55 9.4001C23.55 9.5301 23.57 9.6601 23.6 9.7901L23.61 9.7801ZM24.62 10.3101C24.78 10.1501 24.83 9.8901 24.72 9.6801C24.68 9.5901 24.65 9.4901 24.65 9.3901C24.65 9.2701 24.68 9.1701 24.73 9.0801C24.83 8.8701 24.78 8.6201 24.62 8.4601L18.59 2.4301C18.42 2.2701 18.18 2.2301 17.97 2.3301C17.78 2.4201 17.57 2.4201 17.37 2.3301C17.17 2.2301 16.92 2.2801 16.76 2.4401L8.44 10.7601H7.64L16.88 1.5001C16.88 1.5001 16.91 1.4701 16.95 1.4301L16.97 1.4101C16.97 1.4101 17.03 1.3601 17.04 1.3401C17.22 1.1801 17.44 1.0901 17.67 1.0901C17.67 1.0901 17.69 1.0901 17.7 1.0901C17.94 1.0901 18.17 1.2001 18.36 1.4001C18.4 1.4301 18.44 1.4701 18.47 1.5001L25.57 8.6001C25.78 8.8101 25.9 9.1001 25.9 9.4001C25.9 9.7001 25.79 9.9801 25.57 10.1901L24.96 10.8001C24.9 10.8001 24.83 10.7801 24.76 10.7801H24.14L24.6 10.3201L24.62 10.3101ZM16.14 20.5601C16.25 19.6501 16.96 18.9401 17.86 18.8301H17.94C17.94 18.8301 18.04 18.8201 18.09 18.8201H25.9V23.4201H18.07C17.48 23.4201 16.91 23.1501 16.55 22.6901C16.26 22.3201 16.12 22.0701 16.12 21.6401C16.12 21.5501 16.12 20.6201 16.13 20.5601H16.14ZM17.76 17.7601C16.33 17.9201 15.22 19.0301 15.06 20.4701C15.06 20.5801 15.04 21.5501 15.04 21.6501C15.04 22.3801 15.31 22.8701 15.7 23.3701C16.27 24.0901 17.16 24.5201 18.07 24.5201H25.9V29.4501C25.9 30.0701 25.39 30.5801 24.77 30.5801H2.21C1.59 30.5801 1.08 30.0701 1.08 29.4501V12.9801C1.08 12.3601 1.59 11.8501 2.21 11.8501H24.77C24.85 11.8501 24.94 11.8601 25.04 11.8901C25.55 12.0101 25.9 12.4601 25.9 12.9801V17.7401H18.09C17.98 17.7401 17.88 17.7401 17.76 17.7601Z" fill="#666666"/>
                <path d="M8.06 15.65C5 15.65 2.5 18.14 2.5 21.21C2.5 24.28 4.99 26.77 8.06 26.77C11.13 26.77 13.62 24.28 13.62 21.21C13.62 18.15 11.12 15.66 8.06 15.65ZM12.54 21.21C12.54 23.67 10.53 25.68 8.07 25.68C5.6 25.68 3.6 23.67 3.6 21.21C3.6 18.75 5.61 16.74 8.07 16.74C10.53 16.74 12.54 18.75 12.54 21.21Z" fill="#666666"/>
                <path d="M18.47 22.92C19.44 22.92 20.22 22.13 20.22 21.16C20.22 20.19 19.43 19.41 18.47 19.41C17.51 19.41 16.72 20.2 16.72 21.16C16.72 22.12 17.51 22.92 18.47 22.92ZM18.05 21.16C18.05 20.93 18.24 20.74 18.47 20.74C18.7 20.74 18.89 20.93 18.89 21.16C18.89 21.39 18.7 21.59 18.47 21.59C18.24 21.59 18.05 21.39 18.05 21.16Z" fill="#666666"/>
              </svg>
            </div>
            <div  class="adv-text-container">25% Larger<br/> Approvals</div>
          </div>
          <div class="adv-icon-item">
            <div class="adv-icon-container">
              <svg width="30" height="34" viewBox="0 0 30 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 25.8853V25.75M15.875 25.8853V25.75M15.875 18.4146L16 18.4146M2.75 11.3499H27.25M5.91667 1V3.70032M23.75 1V3.69999M23.75 3.69999H6.25C3.35051 3.69999 1 6.11764 1 9.09996V27.1C1 30.0823 3.35051 32.5 6.25 32.5H23.75C26.6495 32.5 29 30.0823 29 27.1L29 9.09996C29 6.11763 26.6495 3.69999 23.75 3.69999Z" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23.1836 16.4012V18.0589H22.2778V16.4012H23.1836ZM23.0697 25.7038V27.2419H22.1639V25.7038H23.0697ZM23.4513 23.8011C23.4513 23.5922 23.4191 23.4194 23.3545 23.2827C23.2899 23.146 23.1855 23.0264 23.0412 22.9238C22.8969 22.8213 22.7051 22.7187 22.4658 22.6162C21.9607 22.4111 21.5145 22.2004 21.1271 21.9839C20.7435 21.7674 20.4416 21.4978 20.2214 21.175C20.0049 20.8522 19.8966 20.4325 19.8966 19.916C19.8966 19.4451 20.0125 19.0349 20.2441 18.6855C20.4796 18.3362 20.8024 18.0665 21.2126 17.8766C21.6265 17.6829 22.1031 17.5861 22.6424 17.5861C23.0526 17.5861 23.4266 17.6469 23.7646 17.7684C24.1026 17.8899 24.3951 18.0665 24.6419 18.2982C24.8888 18.526 25.0787 18.8071 25.2116 19.1413C25.3445 19.4717 25.411 19.8477 25.411 20.2692H23.4912C23.4912 20.0527 23.4684 19.8666 23.4229 19.7109C23.3811 19.5552 23.3203 19.428 23.2406 19.3293C23.1608 19.2305 23.0678 19.1584 22.9614 19.1128C22.8551 19.0634 22.7393 19.0387 22.6139 19.0387C22.424 19.0387 22.2702 19.0805 22.1525 19.1641C22.0348 19.2438 21.9493 19.3502 21.8962 19.4831C21.843 19.616 21.8164 19.7641 21.8164 19.9274C21.8164 20.0983 21.8449 20.2483 21.9019 20.3774C21.9626 20.5028 22.0652 20.6205 22.2095 20.7306C22.3538 20.837 22.5513 20.9471 22.8019 21.061C23.2956 21.2699 23.7362 21.4864 24.1235 21.7104C24.5109 21.9345 24.8147 22.2099 25.035 22.5365C25.2591 22.8593 25.3711 23.277 25.3711 23.7897C25.3711 24.2834 25.2553 24.705 25.0236 25.0544C24.7919 25.4 24.4691 25.6639 24.0552 25.8462C23.6412 26.0285 23.1627 26.1196 22.6196 26.1196C22.255 26.1196 21.8924 26.0722 21.5316 25.9772C21.1746 25.8823 20.848 25.7285 20.5518 25.5158C20.2593 25.2993 20.0258 25.0126 19.8511 24.6556C19.6764 24.2986 19.589 23.86 19.589 23.3397H21.5088C21.5088 23.5941 21.5392 23.8068 21.5999 23.9777C21.6607 24.1486 21.7424 24.2853 21.8449 24.3879C21.9512 24.4866 22.0709 24.5588 22.2038 24.6043C22.3367 24.6461 22.4753 24.667 22.6196 24.667C22.8133 24.667 22.9709 24.629 23.0924 24.5531C23.214 24.4733 23.3032 24.3689 23.3602 24.2397C23.421 24.1068 23.4513 23.9606 23.4513 23.8011Z" fill="#777777"/>
              </svg>
            </div>
            <div class="adv-text-container">
              Inmediate<br/> Processing
            </div>
          </div>
        </div>
        <div v-if="sfoppid">
          <div class="buttons button_container">
            <a class="button is-link next-button pure-button btn-success" id="continue-plaid-page"
              @click="next">Connect with Plaid</a>
          </div>
        </div>
        <div v-else  id="continue-plaid-page">
          <a :disabled="!sfoppid"
          class="button is-link next-button pure-button btn-success disabled"
            id="continue-plaid-page"
            >Loading..</a
          >
        </div>
        <label class="label" id="use_of_plaid_label">We use <b>Plaid</b> to electronically verify your business revenue.</label>
      </div>
      <div id="image_container_desktop">
        <img
          src="https://cardiff.b-cdn.net/img/iphone_14_plaidv2.png"
          class="iphone_plaid_desktop"
          height="691"
          width="330px"
        />
      </div>
    </div>
  </div>
</template>

<script>

import MyUtils from "@/utils/MyUtils";

export default {
  name: "RenewalApplyVerification",
  components: {},
  props: {
    sfoppid: String,
    message: String
    },
  data() {
    return {
      inputs: {
        bvstarted: true,
      },
      obj: "financials",
      custom_message: "",
    };
  },
  mounted: function () {
    var animation = lottie.loadAnimation({
      container: document.getElementById("shield"), // the dom element that will contain the animation
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "../animations/Shield2.json", // the path to the animation json
    });
    this.custom_message = this.message;
    let first_name = MyUtils.getWithExpiry("first_name");
    if (first_name && first_name != "") {
      let lowerFirstLetter = this.message[0].toLowerCase();
      this.message = this.message.substring(1);
      let new_message = lowerFirstLetter + "" + this.message;
      this.custom_message = "Hey <b>" + first_name + "</b>, " + new_message;
    }
  },
  methods: {
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
  },
};
</script>

<style scoped>
#shield {
  max-width: 300px;
  margin: auto;
  display: block;
}
.iphone_plaid_mobile {
  display: none;
}
#shield {
  max-width: 300px;
  margin: auto;
  display: block;
}
#main_container {
  display: flex;
  background-size: contain;
  /* height: 80vh; */
}
#image_title_container {
  /* mobile */
  background-size: contain;
  max-height: 650px;
  margin-left: 5%;
}
#image_container_desktop {
  margin-top: 48px;
}
#logo {
  padding-top: 64px;
  margin-bottom: 10px;
  width: 763px;
  /* height: 397px; */
}
#iphone_plaid {
  margin-bottom: 32px;
}
/* .button_container {
  margin-left: 3%;
} */
.notes {
  text-align: left;
  font-family: Roboto;
  font-size: 16px;
  margin-right: 8%;
  margin-top: 20px;
}
.button_container {
  height: 48px;
  margin-bottom: 0px;
}
.pure-button {
  border-radius: 24px;
  /* border: 2px solid transparent; */
  font-family: Roboto;
  font-size: 16px;
  /* font-weight: 500; */
  font-weight: 900;
  opacity: 1;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
  letter-spacing: 0.9px;
  /* mobile */
  height: 48px;
  width: 240px;
}
.btn-success {
  background: #28a745 0% 0% no-repeat padding-box;
  color: #ffffff !important;
}
#submit_leads_ad {
  display: none;
}
#plaid_ad_container {
  display: flex;
  /* padding: 0 20px 0 20px; */
  padding-top: 31px;
}
#plaid_ad_container{
  width: 100%
}
@media (max-width: 80em) {
  #image_container_desktop {
    display: none;
  }
  .btn-success {
    margin: 0 auto;
  }
  #image_title_container {
    text-align: center;
    margin-top: -38px;
    padding-top: 48px;

    max-height: none;
    /* background: url("https://cardiff.b-cdn.net/img/gradient-mobile.png"); */
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
  }
  .notes {
    /* margin-left: 32px; */
    margin-left: 5%;
  }
  #image_container_desktop {
    display: none;
  }
  .iphone_plaid_mobile {
    display: block;
    margin: 0 auto;
    margin-top: 8px;
    margin-bottom: 32px;
  }
  #logo {
    padding-top: 0;
    width: 90%;
  }
  #plaid-continue-section{
    width: 50%;
    margin: 0 auto;
  }
}
@media (max-width: 47.999em) {
  .btn-success {
    margin: 0 auto;
  }
  #image_title_container {
    text-align: center;
    margin-top: -38px;
    padding-top: 48px;
    max-height: none;
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
  }
  .notes {
    /* margin-left: 32px; */
    margin-left: 5%;
  }
  #image_container_desktop {
    display: none;
  }
  .iphone_plaid_mobile {
    display: block;
    margin: 0 auto;
    margin-top: 8px;
    margin-bottom: 32px;
  }
  #logo {
    padding-top: 0;
    width: 90%;
  }
  #plaid-continue-section{
    width: 100%;
  }
}
#app-column-lead {
  padding: 0 !important;
}
.container.is-fluid {
  margin-left: 0;
  margin-right: 0;
}

/* start new design */
#success_container {
  margin-top: 64px !important;
  height: 70vh;
}
sup {
  font-size: 50%;
}
.advantages_item {
  font: normal normal normal 20px/24px Roboto;
  letter-spacing: 0px;
  color: #666;
  text-align: left;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 95% */
}
.advantage_separator {
  border-top: 1px solid #ccc;
  padding-bottom: 10px;
  padding-top: 5px;
}
#advantages-icon-main-container{
  margin-bottom: 32px;
  margin-left: 17px;
  justify-content: center;
}
.adv-icon-item{
  padding-top: 22px;
  width: 92px;
  height: 122px;
  flex-shrink: 0;
  background: #F9F9F9;
  text-align: center;
  margin-right: 22px;
}
.adv-icon-container{
  width: 28px;
  height: 31px;
  margin: 0 auto;
  margin-bottom: 11px;
}
.adv-text-container{
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 19px; /* 118.75% */
  text-transform: capitalize;
}
.iphone_plaid_mobile {
  display: none;
}
#shield {
  max-width: 300px;
  margin: auto;
  display: block;
}
#main_container {
  display: flex;
}
#image_title_container {
  background-size: contain;
  margin-left: 5%;
  text-align: center;
}
#image_container_desktop {
  margin-top: 17px;
}
#logo {
  padding-top: 64px;
  width: 200px;
}
#iphone_plaid {
  margin-bottom: 32px;
}
.notes {
  text-align: left;
  font: normal normal normal 16px/19px Roboto;
  letter-spacing: 0px;
  color: #666666;
  opacity: 1;
  margin-right: 8%;
}
.pure-button {
  border-radius: 24px;
  /* border: 2px solid transparent; */
  font-family: Roboto;
  font-size: 16px;
  /* font-weight: 500; */
  font-weight: 900;
  opacity: 1;
  text-align: center;
  font: normal normal 900 16px/40px Roboto;
  letter-spacing: 0.8px;
  color: #ffffff;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 20px;
  padding-right: 20px;
  letter-spacing: 0.9px;
  /* mobile */
  height: 46px;
  width: 240px;
}
.btn-success {
  background: #28a745 0% 0% no-repeat padding-box;
  color: #ffffff !important;
}
#lets_try {
  font: normal normal bold 32px/24px Roboto;
  letter-spacing: 0px;
  color: #000000;
  margin-bottom: 32px;
}

.blue_word{
  color: #2C4CA3;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 19px;
}
#advantages_title{
  /* margin-top: 53px; */
  color: #666;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 95% */
  text-align: center;
}
#subtitle_same_day{
  margin-top: 13px;
  font: normal normal normal 20px / 24px Roboto;
  letter-spacing: 0px;
  color: #666;
  text-align: left;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
}
.advantages_item{
  margin-left: 30px;
}
@media (max-width: 80em) {
}
@media (max-width: 47.999em) {
  .blue_word{
    color: #2C4CA3;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 19px;
  }
  .done_adding_files_container {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  #success_container {
    margin-top: 64px !important;
    height: auto;
  }
  #image_title_container {
    text-align: center;
    margin-top: 0px;
    padding-top: 0px;
    max-height: none;
    background-repeat: no-repeat;
    margin-left: 0;
    background-size: contain;
  }

  .notes {
    /* margin-left: 32px; */
    margin-left: 8%;
  }
  #image_container_desktop {
    display: none;
  }
  .iphone_plaid_mobile {
    display: block;
    margin: 0 auto;
  }
  #logo {
    width: 90%;
    width: 136px;
    height: 52px;
    padding-top: 0;
    display: unset !important;
  }
  .bank_icon {
    display: unset !important;
  }
  .advantages_item {
    font-size: 16px;
    margin-left: 3%;
    margin-right: 10%;
  }
  .pure-button {
    margin: 0 auto;
  }
}
/* new elements */
#connect_word{
  color: #2C4CA3;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
#connect_title{
  color: #666;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}
#continue-plaid-page{
  background-color: #000;
  border: none;
  color: #FFF;
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  /* width: 352px; */
  width: 100%;
  height: 53px;
  border-radius: 0;
  margin: 0 auto;
}
#use_of_plaid_label{
  margin-top: 12px;
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 146.154% */
}
.pre_selecte_offer_label{
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.pre_selecte_offer_label_amount{
  color: #2C4CA3;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>